// ===============================================
// 🧭 HEADER COM FILTRO POR CARGO - INHOLDING
// ===============================================
// Arquivo: frontend/src/components/Header.js

import React, { useState, useTransition } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';
import './Header.css';

// Prefetch de chunks ao passar o mouse (melhora INP no clique)
const prefetchRoute = (path) => {
  if (path === '/expedition') import('../pages/ExpeditionPage');
  else if (path === '/receipt') import('../pages/ReceiptPage');
  else if (path === '/search') import('../pages/LinhaTempo');
};

const Header = () => {
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [isPending, startTransition] = useTransition();
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const handleNavClick = (e, path) => {
    e.preventDefault();
    startTransition(() => navigate(path));
  };

  const handleLogout = async () => {
    setShowUserMenu(false);
    
    const loadingToast = toast.loading('Fazendo logout...');
    
    try {
      await logout();
      toast.success('Logout realizado com sucesso!', { id: loadingToast });
      navigate('/login');
    } catch (error) {
      toast.error('Erro ao fazer logout', { id: loadingToast });
    }
  };

  const getInitials = (nome) => {
    if (!nome) return 'U';
    return nome
      .split(' ')
      .map(word => word.charAt(0))
      .join('')
      .substring(0, 2)
      .toUpperCase();
  };

  // ===============================================
  // 📋 MENU BASEADO NO CARGO DO USUÁRIO
  // ===============================================
  
  const getMenuItems = () => {
    const userRole = user?.cargo?.toLowerCase();
    
    const allItems = [
      {
        path: '/administrator',
        label: 'Admin',
        icon: '👑',
        roles: ['administrador']
      },
      {
        path: '/expedition',
        label: 'Expedição',
        icon: '📦',
        roles: ['administrador', 'expedição', 'expedicao']
      },
      {
        path: '/receipt',
        label: 'Loja',
        icon: '🏪',
        roles: ['administrador', 'loja']
      },
      {
        path: '/search',
        label: 'Pesquisa',
        icon: '🔍',
        roles: ['administrador', 'expedição', 'expedicao', 'loja']
      }
    ];

    // Filtrar itens baseado no cargo do usuário
    return allItems.filter(item => 
      item.roles.includes(userRole)
    );
  };

  const menuItems = getMenuItems();

  return (
    <header className="header">
      <div className="header-container">
        {/* Logo e Título */}
        <div className="header-brand">
          <div className="brand-icon">📦</div>
          <div className="brand-text">
            <h1>PCP</h1>
            <span>Controle de Expedição</span>
          </div>
        </div>

        {/* Menu de Navegação Filtrado - prefetch no hover + startTransition no clique (INP) */}
        <nav className="header-nav">
          {menuItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`nav-item ${location.pathname === item.path ? 'active' : ''} ${isPending ? 'nav-pending' : ''}`}
              onClick={(e) => handleNavClick(e, item.path)}
              onMouseEnter={() => prefetchRoute(item.path)}
            >
              <span className="nav-icon">{item.icon}</span>
              <span className="nav-label">{item.label}</span>
            </Link>
          ))}
        </nav>

        {/* Menu do Usuário */}
        <div className="header-user">
          <div className="user-info">
            <span className="user-name">{user?.nome || 'Usuário'}</span>
            <span className="user-role">{user?.cargo || 'Operador'}</span>
          </div>
          
          <div className="user-menu">
            <button
              className="user-avatar"
              onClick={() => setShowUserMenu(!showUserMenu)}
            >
              <span className="avatar-text">{getInitials(user?.nome)}</span>
              <div className="avatar-indicator"></div>
            </button>

            {showUserMenu && (
              <>
                <div
                  className="menu-overlay"
                  onClick={() => setShowUserMenu(false)}
                />
                <div className="user-dropdown">
                  <div className="dropdown-header">
                    <div className="dropdown-avatar">
                      <span>{getInitials(user?.nome)}</span>
                    </div>
                    <div className="dropdown-info">
                      <div className="dropdown-name">{user?.nome}</div>
                      <div className="dropdown-email">{user?.email}</div>
                      <div className="dropdown-role">{user?.cargo}</div>
                    </div>
                  </div>
                  
                  <div className="dropdown-divider"></div>
                  
                  <button
                    className="dropdown-item logout"
                    onClick={handleLogout}
                  >
                    🚪 Sair
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;